import React, { useCallback, useEffect, useState } from 'react';

import Pagination from '@mui/material/Pagination';
import PaginationItem from '@mui/material/PaginationItem';
import { useParams } from 'react-router';
import { useNavigate } from 'react-router-dom';

import { ArrowLeft, ArrowRight } from '../../../components/icons';

import '../styles/style.css';

export default function CustomPagination({
  url,
  setSkip,
  totalCount,
  number,
  isCirculationAll,
}) {
  const params = useParams();
  const pageNumber = Number(params.number);
  const [pageCount, setPageCount] = useState(1);
  const navigate = useNavigate();
  const handleChange = (event, value) => {
    if (!isCirculationAll) {
      navigate(`${url}${value}`);
      setSkip((value - 1) * 6);
    } else {
      navigate(`/circulations/${value}`);
      setSkip((value - 1) * 6);
    }
  };
  const handlePage = useCallback(() => {
    let count = Math.ceil(totalCount / 6);
    if (totalCount) {
      setPageCount(count);
    }
  }, [totalCount]);

  useEffect(() => {
    setSkip((number - 1) * 6);
    handlePage();
  }, [handlePage, number, setSkip, totalCount]);
  return (
    <div className="custom-pagination">
      <Pagination
        count={pageCount}
        page={pageNumber}
        onChange={handleChange}
        renderItem={(item) => (
          <PaginationItem
            components={{ previous: ArrowLeft, next: ArrowRight }}
            {...item}
          />
        )}
      />
    </div>
  );
}
